














import { Component, Vue, Prop } from 'vue-property-decorator';
import ChangeLanguageIconSp from '@/components/ChangeLanguageIconSp.vue';
import ChangeLanguageIconPc from '@/components/ChangeLanguageIconPc.vue';

@Component({
  components: { ChangeLanguageIconSp, ChangeLanguageIconPc }
})
export default class PageHeader extends Vue {
  @Prop({ type: Boolean, default: false })
  displayLanguageIcon!: boolean;
}
